import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { Card, StatusPill, Btn } from '../components/fiori/Fiori';

export default function AccessDenied({ message, requiredRole }) {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-screen bg-canvas px-6">
      <Card className="w-full max-w-md p-8 text-center">
        <span className="w-16 h-16 rounded-2xl bg-danger-bg flex items-center justify-center mx-auto mb-5">
          <ShieldAlert className="w-8 h-8 text-danger" />
        </span>

        <h1 className="text-2xl font-bold text-ink-strong tracking-tight mb-3">
          {t('accessDenied.title')}
        </h1>

        <p className="text-sm text-slate-600 mb-5">
          {message || t('accessDenied.noPermission')}
        </p>

        <div className="rounded-lg border border-hairline bg-slate-50 p-4 mb-6 text-left space-y-2">
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-medium text-slate-700">{t('accessDenied.currentRole')}</span>
            <StatusPill tone="neutral">{user?.role || t('accessDenied.unknown')}</StatusPill>
          </div>
          {requiredRole && (
            <div className="flex items-center justify-between gap-3">
              <span className="text-sm font-medium text-slate-700">{t('accessDenied.requiredRole')}</span>
              <StatusPill tone="brand">{requiredRole}</StatusPill>
            </div>
          )}
        </div>

        <div className="flex gap-2 justify-center">
          <Btn variant="secondary" onClick={() => navigate(-1)}>
            <ArrowLeft className="w-4 h-4" />
            {t('accessDenied.goBack')}
          </Btn>

          <Btn onClick={() => navigate('/')}>
            {t('accessDenied.goHome')}
          </Btn>
        </div>
      </Card>
    </div>
  );
}
